import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CollectionStore from '../../stores/CollectionStore';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs';
import CollectionDetail from '../../components/CollectionDetail';
import styles from '../BaseContainer/index.sass';

class CollectionContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  getHelmetProps(store, collection) {
    if(!collection) {return null;}
    let description = collection.description;
    let title = `${collection.title} – ${store.name}`;
    let helmetProps = {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };

    let coverPhoto = collection.cover_photo_hash.getChildByWidth(640);
    let coverPhotoUrl;
    if(coverPhoto && coverPhoto.width && coverPhoto.height) {
      coverPhotoUrl = coverPhoto.url;
      helmetProps.meta.push({property: 'og:image:width', content: coverPhoto.width});
      helmetProps.meta.push({property: 'og:image:height', content: coverPhoto.height});
    } else {
      coverPhotoUrl = collection.cover_photo_hash.getClosestToTarget(640);
    }
    helmetProps.meta.push({property: 'og:image', content: coverPhotoUrl});
    helmetProps.meta.push({name: 'twitter:image', content: coverPhotoUrl});
    return helmetProps;
  }

  render() {
    let { collection, pagination, loading, shoppingCart, store } = this.props;
    let collectionDetailProps = {
      store,
      collection,
      pagination,
      loading
    };
    let breadcrumbsProps = {
      links: [{routeName: 'storeLandingPage'}, {routeName: 'collections'}]
    };

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store, collection)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <CollectionDetail {...collectionDetailProps} />
      </section>
    );
  }
}

CollectionContainer = connectToStores(CollectionContainer, [CollectionStore], (context, props) => {
  let { slug } = props.currentRoute.params;
  return context.getStore(CollectionStore).getCollectionStateBySlug(slug);
});

export default CollectionContainer;



// WEBPACK FOOTER //
// banquet/containers/CollectionContainer/index.js